import { cn } from "@/lib/utils";

interface SectionTitleProps {
  title: string;
  subtitle?: string;
  description?: string;
  centered?: boolean;
  className?: string;
}

export function SectionTitle({
  title,
  subtitle,
  description,
  centered = false,
  className,
}: SectionTitleProps) {
  return (
    <div className={cn("mb-10", centered && "text-center", className)}>
      {subtitle && (
        <p className="mb-2 font-pixel text-xs text-primary">{subtitle}</p>
      )}
      <h2 className="text-3xl font-bold tracking-tight md:text-4xl">{title}</h2>
      {description && (
        <p className="mt-3 max-w-2xl text-muted-foreground">
          {description}
        </p>
      )}
    </div>
  );
}
